<template>
  <div class="container" v-html="content">
    
  </div>
</template>

<script>
import {selectArticleDetails} from '../../api/article/selectArticleDetails'  // 查文章详情
  export default {
    data() {
      return {
        catId: 35,
        content: ''
      }
    },
  created() {
    this.getArticleDetails()
  },
  methods: {
    getArticleDetails() {
      selectArticleDetails({catId: this.catId}).then(res => {
        if(res.data.length === 0) return; 
        this.content = res.data[0].content
      }).catch(err => {
        this.$message.error(err.message)
      })
    }
  },
  }
</script>

<style lang="scss" scoped>
  /deep/img {
    width: 100%;
    height: auto;
  }
  
</style>